import { render, staticRenderFns } from "./PassChallenge.vue?vue&type=template&id=72b62778&"
import script from "./PassChallenge.vue?vue&type=script&lang=js&"
export * from "./PassChallenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports